/**
 * Agent Atoms - State management for AI Agents
 *
 * NO LOCAL TYPES - All types come from types/api.ts or backend schemas
 */

import { atom } from "jotai";
import type { Agent } from "@/isomorphic/schemas";
import type { AtomStatus, AtomError } from "@/frontend/types/atoms";

// ============================================================================
// ATOMS
// ============================================================================

/**
 * Internal atom: Workspace agents (from API)
 * Exported for use in agent-actions.ts
 */
export const _apiWorkspaceAgentsAtom = atom<Agent[]>([]);

export const workspaceAgentsStatusAtom = atom<AtomStatus>("init");
export const workspaceAgentsErrorAtom = atom<AtomError>(null);
export const currentAgentAtom = atom<Agent | null>(null);
export const currentAgentStatusAtom = atom<AtomStatus>("init");

/**
 * Public atom: Workspace agents
 */
export const workspaceAgentsAtom = atom<Agent[]>((get) => {
  return get(_apiWorkspaceAgentsAtom);
});

// ============================================================================
// NOTE: All action functions have been moved to actions/agent-actions.ts
// This file now only contains atom definitions (state)
// ============================================================================
